module.exports = __webpack_public_path__ + "static/media/invoiceGreyIcon.e710d98e.svg";